import { render, staticRenderFns } from "./ModalErrorCreate.vue?vue&type=template&id=6ed51024&"
import script from "./ModalErrorCreate.vue?vue&type=script&lang=js&"
export * from "./ModalErrorCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports